export default "__VITE_ASSET__BiaiDNHz__"